import ViewMatch from './ViewMatch';

export default ViewMatch;